import { status } from 'skin/event/status';
import check from './check';

const row = (obj, form, story, data, d, action) => {
	switch (obj.table) {
		case 'check':
			return check(obj, form, story, data, d, action);
		default:
	}
	return status.action;
};

export default row;
